<div class="company-edit-profile light-grey-background pb-60">
    <div class="container">
        <form (ngSubmit)="onSubmit(editForm)" #editForm="ngForm" class="edit-main-account">
            <div class="form-row">
                <div class="col-md-6 form-group">
                    <input type="text" id="lastName" class="form-control"  name="lastName" #lastName="ngModel"  placeholder="{{'LOGIN.LAST_NAME' | translate}}" [ngModel]=userData.lastName required (change)="letterCheck(lastName.name, lastName.value)">
                    <span class="help-block" *ngIf="!lastName.valid && (lastName.touched || editForm.submitted)">{{'VALIDATION.REQUIRED' | translate}}</span>
                    <span class="help-block" *ngIf="lastNameFail">{{'VALIDATION.ONLY_LETTERS' | translate}}</span>
                </div>
                <div class="col-md-6 form-group">
                    <input type="text" id="firstName" class="form-control"  name="firstName" #firstName="ngModel"  placeholder="{{'LOGIN.FIRST_NAME' | translate}}" [ngModel]=userData.firstName required (change)="letterCheck(firstName.name, firstName.value)">
                    <span class="help-block" *ngIf="!firstName.valid && (firstName.touched || editForm.submitted)">{{'VALIDATION.REQUIRED' | translate}}</span>
                    <span class="help-block" *ngIf="firstNameFail">{{'VALIDATION.ONLY_LETTERS' | translate}}</span>
                </div>
                <div class="col-md-12 form-group">
                    <input type="email" id="email" class="form-control"  name="email" #email="ngModel"  placeholder="Email" [ngModel]=userData.email  disabled required>
                </div>
                <div class="col-md-12 form-group">
                    <select placeholder="Country" [(ngModel)]="selectedCountry" (change)="changeCountry($event)"
                            class="form-control" name="userCountry"  id="userCountry" #userCountry="ngModel" required>
                        <option value=" " selected disabled>{{'DROPDOWN.COUNTRY' | translate}}</option>
                        <option *ngFor="let country of Countries">{{country.name}}</option>
                    </select>
                    <span class="help-block" *ngIf="!userCountry.valid && (userCountry.touched || editForm.submitted)">{{'VALIDATION.REQUIRED' | translate}}</span>
                </div>
                <div class="col-md-12 form-group">
                    <select placeholder="State" class="form-control" name="userCity" id="userCity"
                            [(ngModel)]="selectedCity" #userCity="ngModel" required>
                        <option [ngValue]="" selected disabled>{{'DROPDOWN.CITY' | translate}}</option>
                        <option *ngFor="let city of cities">{{city}}</option>
                    </select>
                    <span class="help-block" *ngIf="!userCity.valid && (userCity.touched || editForm.submitted)">{{'VALIDATION.REQUIRED' | translate}}</span>
                </div>
                <div class="col-md-12 form-group">
                    <input type="text" id="address" class="form-control" ngModel name="address" #address="ngModel"  placeholder="Adresa" [ngModel]=userData.address>
                </div>

                <div class="col-md-12">
                    <app-form-message [success]="formResponse" [customSuccessMessage]="customSuccessMessage" *ngIf="formSent"></app-form-message>
                </div>

                <button type="submit" class="green-button" [disabled]="!editForm.valid">{{'BUTTONS.SEND' | translate}}</button>
            </div>
        </form>

    </div>
</div>
